import { render, staticRenderFns } from "./BadgeBatteryAlerts.vue?vue&type=template&id=037d0543"
import script from "./BadgeBatteryAlerts.vue?vue&type=script&lang=js"
export * from "./BadgeBatteryAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports